export enum EHolidayType {
  SOLAR = 1,
  LUNAR = 2,
  WEEKS = 3
}
